<template>
    <form @submit.prevent="sendForm">
        <div :class="{error: $v.castingForm.name.$error}" class="form-group">
            <input
                    type="text"
                    :placeholder="$t('casting.name')"
                    class="form-control"
                    :disabled="loading"
                    v-model="castingForm.name"
                    @input="$v.castingForm.name.$touch"
            >
            <template v-if="$v.castingForm.name.$error">
                <p v-if="!$v.castingForm.name.required" class="error-message">
                    {{$t('validations.required', {field: $t('fields.name')})}}
                </p>
            </template>
        </div>

        <div :class="{error: $v.castingForm.email.$error}" class="form-group">
            <input
                    type="email"
                    :placeholder="$t('casting.email')"
                    class="form-control"
                    :disabled="loading"
                    v-model="castingForm.email"
                    @input="$v.castingForm.email.$touch"
            >
            <template v-if="$v.castingForm.email.$error">
                <p v-if="!$v.castingForm.email.required" class="error-message">
                    {{$t('validations.required', {field: $t('fields.email')})}}
                </p>
            </template>
        </div>

        <div :class="{error: $v.castingForm.whatsapp.$error}" class="form-group">
            <input
                    class="form-control"
                    :disabled="loading"
                    type="text"
                    v-model="castingForm.whatsapp"
                    :placeholder="$t('casting.whatsapp')"
                    @input="$v.castingForm.whatsapp.$touch"
            >
            <template v-if="$v.castingForm.whatsapp.$error">
                <p v-if="!$v.castingForm.whatsapp.required" class="error-message">
                    {{$t('validations.required', {field: $t('fields.whatsapp')})}}
                </p>
            </template>
        </div>

        <div class="captcha-container" v-if="recaptchaPublicKey">
            <vue-recaptcha
                    ref="recaptcha"
                    :sitekey="recaptchaPublicKey"
                    :loadRecaptchaScript="true"
                    :theme="'light'"
                    @verify="castingForm.recaptcha = $event"
                    @expire="castingForm.recaptcha = null"
            />
            <template v-if="$v.castingForm.recaptcha.$error">
                <p v-if="!$v.castingForm.recaptcha.required" class="error-message">
                    {{$t('validations.captcha')}}
                </p>
            </template>
        </div>

        <div class="messages">
            <div v-for="(errors, errorKey) in castingErrors" :key="errorKey">
                <p
                    v-for="error in errors"
                    style="text-align: center"
                    :key="error"
                >
                    {{error}}
                </p>
            </div>
        </div>

        <div v-if="!loading" class="buttons">
            <button type="submit" class="btn-action">
                {{$t('casting.btn-action')}}
            </button>
        </div>
        <Spinner v-else/>
    </form>
</template>

<script>
  import Spinner from "./Spinner";
  import { required, minLength, email, requiredIf } from 'vuelidate/lib/validators';
  import EventBus from '../eventbus';
  import languages from './../lang/languages';
  import VueRecaptcha from 'vue-recaptcha';

  export default {
      components: {
          Spinner,
          VueRecaptcha,
      },
      data(){
          return {
              castingForm: {
                  name: '',
                  email: '',
                  whatsapp: '',
                  recaptcha: null,
              },
              castingErrors: {},
              loading: false,
          }
      },
      methods: {
        sendForm(){
          if(this.$v.castingForm.$invalid){
              return this.$v.castingForm.$touch();
          }

          this.loading = true;
          this.castingErrors = [];
          this.$http.post('casting', this.castingForm).then(() => {
            this.loading = false;
            this.castingErrors = {response: [this.$t('casting.success')]};
            // redirecciono si todo salió bien
            setTimeout(()=>this.$router.push({name: 'home'}), 3000);
          }).catch(() => {
            this.loading = false;
            this.castingErrors = {general: [this.$t('error')]};
          });
        }
      },
      mounted() {
          if(this.$route.query.email){
              this.castingForm.email = this.$route.query.email;
          }
      },
      computed: {
          recaptchaPublicKey(){
              return process.env.VUE_APP_RECAPTCHA_PUBLIC_KEY;
          }
      },
      validations() {
          return {
              castingForm: {
                  name: {
                      required,
                      minLength: minLength(4)
                  },
                  email: {
                      required,
                      email,
                      minLength: minLength(4)
                  },
                  whatsapp: {
                      minLength: minLength(4)
                  },
                  recaptcha: {
                      required: requiredIf(() => this.recaptchaPublicKey)
                  }
              },
          }
      },
      watch: {
          loading(){
              this.$emit('loadingChange', this.loading);
          },
      },
  }
</script>

<style scoped lang="scss">
    @import '../styles/variables';
    @import '../styles/classes';

    .buttons{
        margin-bottom: 30px;
    }

    .btn-action{
        @extend %fresh-btn;
        display: block;
        width: 100%;
        padding: 1em;
    }

    .password-options{
        text-align: center;
    }
</style>
